import axios from 'axios';

import { clearToken, getToken } from '../utils/auth';

const API_BASE = process.env.VUE_APP_API_BASE || '/api';
const DEV_FALLBACK_API_BASE =
  process.env.VUE_APP_DEV_FALLBACK_API_BASE || 'http://localhost:3001/api';

const request = axios.create({
  baseURL: API_BASE,
  timeout: 15000
});

request.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const shouldRetryWithDevFallback = (error) => {
  if (typeof window === 'undefined') return false;

  const config = error?.config;
  const response = error?.response;
  const method = String(config?.method || '').toLowerCase();
  const hostname = window.location.hostname;

  return (
    !!config &&
    !config.__retriedWithDevFallback &&
    method === 'delete' &&
    typeof config.baseURL === 'string' &&
    config.baseURL.startsWith('/') &&
    (hostname === 'localhost' || hostname === '127.0.0.1') &&
    response?.status === 404 &&
    response?.data?.message === 'Route not found'
  );
};

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
    }

    if (shouldRetryWithDevFallback(error)) {
      return request.request({
        ...error.config,
        baseURL: DEV_FALLBACK_API_BASE,
        __retriedWithDevFallback: true
      });
    }

    return Promise.reject(error);
  }
);

export default request;
